import { BOOKING_REQUEST, BOOKING_SUCCESS, BOOKING_FAILURE, BOOKING_EDIT_PAGE_SUCCESS, BOOKING_DELETE_CONFIRM, BOOKING_DELETE_CONFIRM_DECLINE, BOOKING_DELETE_FAILURE, BOOKING_DELETE_SUCCESS, BOOKING_PROJECT_OPTIONS_SUCCESS, BOOKING_PROJECT_OPTIONS_FAILURE, SET_PROJECT_UNIT_OPTIONS } from "../../redux/action_constant";
import { ProjectActions, BookingInterface, BookingState, ProjectOptionInterface, ProjectUnitOptionInterface } from "./BookingTypes";


const initialState: BookingState = {
    pending: false,
    error: null,
    loading: false,
    bookingList: [] as BookingInterface[],
    next_offset: 0,
    listCount: 0,
    editBooking: {} as BookingInterface,
    showDeleteModal: false,
    deleteBooking: {} as BookingInterface,
    projectOptions: [] as ProjectOptionInterface[],
    projectUnitOptions: [] as ProjectUnitOptionInterface[],
    totalBookedArea: 0,
    totalBookingValue: 0,
    totalRecivedAmount: 0,
};


const BookingReducer = (state = initialState, action: ProjectActions) => {
    switch (action.type) {
        case BOOKING_REQUEST:
            return {
                ...state,
                loading: true,
                editBooking: {} as BookingInterface,
                showDeleteModal: false,
                deleteBooking: {} as BookingInterface,
            };
        case BOOKING_SUCCESS:
            return {
                ...state,
                loading: false,
                bookingList: action.payload.list,
                next_offset: action.payload.next_offset,
                listCount: action.payload.count,
                totalBookedArea: action.payload.totalBookedArea,
                totalBookingValue: action.payload.totalBookingValue,
                totalRecivedAmount: action.payload.totalRecivedAmount,
                error: null,
            };
        case BOOKING_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                bookingList: [],
                next_offset: -1,
                listCount: 0,
            };
        case BOOKING_EDIT_PAGE_SUCCESS:
            return {
                ...state,
                editBooking: action.payload,
            };
        case BOOKING_DELETE_CONFIRM:
            return {
                ...state,
                showDeleteModal: true,
                deleteBooking: action.payload,
            };
        case BOOKING_DELETE_CONFIRM_DECLINE:
            return {
                ...state,
                showDeleteModal: false,
                deleteBooking: {} as BookingInterface,
            };
        case BOOKING_DELETE_FAILURE:
            return {
                ...state,
                showDeleteModal: false,
                deleteBooking: {} as BookingInterface,
            };
        case BOOKING_DELETE_SUCCESS:
            return {
                ...state,
                showDeleteModal: false,
                deleteBooking: {} as BookingInterface,
            };
        case BOOKING_PROJECT_OPTIONS_SUCCESS:
            return {
                ...state,
                projectOptions: action.payload,
            };
        case BOOKING_PROJECT_OPTIONS_FAILURE:
            return {
                ...state,
                projectOptions: [],
            };
        case SET_PROJECT_UNIT_OPTIONS:
            return {
                ...state,
                projectUnitOptions: action.payload,
            };

        default:
            return {
                ...state,
            };
    }
};

export default BookingReducer;   